// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"WorkshopSessionsContent_wrapper__z3R0Q"};